// extracted by mini-css-extract-plugin
module.exports = {"sharedStyles":"\"../../themes/sharedStyles.module.css\"","button":"Button_button__3QF_k sharedStyles_standardTextStructure__2HVr-"};